import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const PopUpBox = styled(FocusNode)`
  position: fixed;
  background: ${(props) => props.theme.colors.dialogPopup.overlay};
  width: 1920px;
  height: 1080px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
`
export const PopUpElem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: auto;
  min-width: 30%;
  max-width: 60%;
  height: auto;
  min-height: 30%;
  padding: 40px;
  border: 4px solid ${(props) => props.theme.colors.dialogPopup.border};
  overflow: hidden;
  /* May lead to chrome craches (v107) */
  /* transition: --dialogPopupBgStart 0.5s, --dialogPopupEnd 0.5s; */
  /* background: radial-gradient(
    85.28% 210.12% at 10.34% 14.72%,
    var(--dialogPopupBgStart) 0%,
    var(--dialogPopupEnd) 50%
  ); */
  background: radial-gradient(
    85.28% 210.12% at 10.34% 14.72%,
    ${(props) => props.theme.colors.dialogPopup.background.start} 0%,
    ${(props) => props.theme.colors.dialogPopup.background.end} 100%
  );
`
export const Title = styled.h2`
  width: 100%;
  font-size: 40px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.dialogPopup.title};
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 24px;
  text-align: center;
`
export const Description = styled.p`
  width: 100%;
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-line;
  padding-bottom: 65px;
  max-width: 1000px;
  margin: 0 auto;
  color: ${(props) => props.theme.colors.dialogPopup.text};
`
